module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Title Page"
    }
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('span', {
    attrs: {
      "aria-label": " page iii. ",
      "epub:type": "pagebreak",
      "id": "page_iii",
      "role": "doc-pagebreak"
    }
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Lioness Rampant, by Tamora Pierce. Atheneum Books for Young Readers. New York | London | Toronto | Sydney | New Delhi.",
      "src": "e9781439132081/images/title.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c313f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439132081/xhtml/title.vue
// module id = 57
// module chunks = 0